import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import SelectInput from '../types/select-input';
import { StandardInputField } from '../types/standard-input-field';
import { composeValidators, isValidSSNFactory, requiredField, valueNotAllowed } from './validator';
// TODO: KEEP THE "OUT-COMMENTED" CODE UNTIL FURTHER NOTICE AS THIS MIGHT BE REAPPLIED LATER!

const getActorSection = (actorInfo, key, countryOptions, isFromServer, removeAddedBoardMember, extraFields) => {
  var _actorInfo$publicId;
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: "actor-section-wrapper"
  }, !isFromServer && removeAddedBoardMember && /*#__PURE__*/React.createElement(IconButton, {
    className: "sgw-button remove-icon",
    id: "removeItem",
    onClick: removeAddedBoardMember,
    icon: IconTypes.KRYSS_24,
    screenReaderText: "fjern til styremedlem"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sgw-layout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sgw-layout-item"
  }, /*#__PURE__*/React.createElement(StandardInputField, {
    label: "Fornavn",
    name: "".concat(key, ".firstName"),
    validate: requiredField,
    disabled: isFromServer && actorInfo.firstName !== undefined
  })), /*#__PURE__*/React.createElement("div", {
    className: "sgw-layout-item"
  }, /*#__PURE__*/React.createElement(StandardInputField, {
    label: "Etternavn",
    name: "".concat(key, ".lastName"),
    validate: requiredField,
    disabled: isFromServer && actorInfo.lastName !== undefined
  })), /*#__PURE__*/React.createElement("div", {
    className: "sgw-layout-item"
  }, /*#__PURE__*/React.createElement(StandardInputField, {
    label: "F\xF8dselsnummer / D-nummer",
    name: "".concat(key, ".publicId.value"),
    validate: composeValidators(requiredField, isValidSSNFactory(isFromServer)),
    disabled: isFromServer && ((_actorInfo$publicId = actorInfo.publicId) === null || _actorInfo$publicId === void 0 ? void 0 : _actorInfo$publicId.token) !== undefined
  })), /*#__PURE__*/React.createElement("div", {
    className: "sgw-layout-item"
  }, /*#__PURE__*/React.createElement(SelectInput, {
    label: "Bostedsland",
    name: "".concat(key, ".country"),
    values: [{
      text: 'Velg',
      value: 'velg',
      key: '0'
    }, ...countryOptions],
    validate: composeValidators(requiredField, value => valueNotAllowed(value, 'velg', 'Velg')),
    disabled: isFromServer && actorInfo.address !== undefined
  })), /*#__PURE__*/React.createElement("div", {
    className: "sgw-layout-item"
  }, /*#__PURE__*/React.createElement(SelectInput, {
    label: "F\xF8deland",
    name: "".concat(key, ".birthCountry"),
    values: [{
      text: 'Velg',
      value: 'velg',
      key: '0'
    }, ...countryOptions],
    validate: composeValidators(requiredField, value => valueNotAllowed(value, 'velg', 'Velg')),
    disabled: isFromServer && actorInfo.countryOfBirth !== undefined
  })), /*#__PURE__*/React.createElement("div", {
    className: "sgw-layout-item"
  }, actorInfo.citizenship && actorInfo.citizenship.length > 0 ? /*#__PURE__*/React.createElement(StandardInputField, {
    label: "Statsborgerskap",
    name: "".concat(key, ".citizenship"),
    validate: requiredField,
    disabled: true
  }) : /*#__PURE__*/React.createElement(SelectInput, {
    label: "Statsborgerskap",
    name: "".concat(key, ".citizenship"),
    values: [{
      text: 'Velg',
      value: 'velg',
      key: '0'
    }, ...countryOptions],
    validate: composeValidators(requiredField, value => valueNotAllowed(value, 'velg', 'Velg'))
  })), extraFields === null || extraFields === void 0 ? void 0 : extraFields.map(extraField => {
    return /*#__PURE__*/React.createElement("div", {
      className: "sgw-layout-item",
      key: extraField.props.name
    }, extraField);
  })));
};
export default getActorSection;